!function () {
    "use strict";
    customElements.get("quantity-counter") || customElements.define("quantity-counter", class extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.input = this.querySelector("input"),
                this.changeEvent = new Event("change", {
                    bubbles: !0
                }),
                this.buttonClickEvent = this.onButtonClick.bind(this),
                this.onQuantityChangeEvent = this.onQuantityChange.bind(this),
                this.input.addEventListener("change", this.onQuantityChangeEvent),
                this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.buttonClickEvent)))
        }
        onButtonClick(t) {
            t.preventDefault();
            const e = this.input.value,
                n = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");

            if ("increase" === n.name) {
                this.input.stepUp();
            } else if ("decrease" === n.name) {
                this.input.stepDown();
            }

            if (e !== this.input.value) {
                //console.log("Product ID:", this.input.dataset.id); // Log data-id
                this.input.dispatchEvent(this.changeEvent);
            }
        }

        async onQuantityChange() {
            if (this.input.name === "updates[]") {
                await this.updateCart();
            }
        }

        async updateCart() {
            if (this.quantityValue === "") return;

            const productId = parseInt(this.input.dataset.id, 10);
            const updatedQuantity = parseInt(this.input.value, 10);
            const cartKey = this.input.dataset.productitemId;
            try {
                // Fetch the cart data
                const response = await fetch('/cart.js');
                const cart = await response.json();
                const totalCartQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
                const cartItem = cart.items.find(item => item.variant_id === productId);
                const currentProductQty = cartItem ? cartItem.quantity : 0;
                const errorElement = document.querySelector(`.cart-items-error[data-productitem-id="${cartKey}"]`);
                if (updatedQuantity > 5) {

                    //console.log(`Limit exceeded: You can only add up to 5 units of this product. Current: ${currentProductQty} with cart key ${cartKey}`);
                    //check in document for class drawer--cart if it does not contains is-open in its classlist
                    if (!document.querySelector('.drawer--cart').classList.contains('is-open')) {
                        const updatingProductErrors = document.querySelectorAll(`.product-error-wrapper[data-variant-id="${cartKey}"]`);
                        updatingProductErrors.forEach((error) => {
                            const errorMessage = error.querySelector('.product-error-message');
                            if (errorMessage) {
                                errorMessage.textContent = `Limit reached! You can add up to 5 units only.`;
                                error.style.display = 'flex';
                                error.style.justifyContent = 'center';
                                error.style.alignItems = 'center';
                                setTimeout(() => {
                                    errorMessage.textContent = '';
                                    error.style.display = 'none';
                                }, 2000);
                            }
                        });
                    }                    
                    this.input.value = Math.min(currentProductQty, 5);
                    if (errorElement) {
                        errorElement.textContent = `Limit reached! You can add up to 5 units only.`;
                        errorElement.style.display = 'flex';
                        setTimeout(() => {
                            errorElement.textContent = '';
                            errorElement.style.display = 'none';
                        }, 2000);
                    }
                    return;
                }
                if ((totalCartQuantity - currentProductQty + updatedQuantity) > 25) {
                    if (!document.querySelector('.drawer--cart').classList.contains('is-open')) {
                        const updatingProductError = document.querySelector(`.product-error-wrapper[data-variant-id="${cartKey}"]`);
                        updatingProductError.querySelector('.product-error-message').textContent = `Cart limit reached! You can add up to 25 items only.`;
                        updatingProductError.style.display = 'flex';
                        setTimeout(() => {
                            updatingProductError.querySelector('.product-error-message').textContent = '';
                            updatingProductError.style.display = 'none';
                        }, 2000);
                    }
                    this.input.value = currentProductQty;
                    if (errorElement) {
                        errorElement.textContent = `Cart limit reached! You can add up to 25 items only.`;
                        errorElement.style.display = 'flex';
                        setTimeout(() => {
                            errorElement.textContent = '';
                            errorElement.style.display = 'none';
                        }, 2000);
                    }
                    return;
                }
                //console.log(`Updating cart: Product ID: ${productId}, New Quantity: ${updatedQuantity}`);
                this.dispatchEvent(new CustomEvent("theme:cart:update", {
                    bubbles: true,
                    detail: {
                        id: productId,
                        quantity: updatedQuantity
                    }
                }));
                const body = document.querySelector('body');
                if (body.classList.contains('template-product')) {
                    const quantityInput = document.querySelector('.quantity-selector .quantity__input');
                    quantityInput.value = updatedQuantity;
                    if (updatedQuantity === 0) {
                        quantityInput.value = 1;
                        quantityInput.closest('.product__submit__item').classList.remove('is-added');
                    }
                    const regimeproductSection = document.getElementById('pdp-complete-your-regime');
                    if (regimeproductSection) {
                        const regimequantityWrapper = regimeproductSection.querySelector(`.quantity-wrapper[data-variant-id="${cartKey}"]`);
                        if (regimequantityWrapper) {
                            const regimecartQuantityElement = regimequantityWrapper.querySelector(".cart-quantity");
                            if (regimecartQuantityElement) {
                                if (updatedQuantity === 0) {
                                    regimequantityWrapper.classList.remove("active-qty");
                                    regimequantityWrapper.parentElement.querySelector('.add-to-cart-btn')?.classList.remove('hide-atc_btn');
                                    return;
                                }
                                regimecartQuantityElement.textContent = updatedQuantity;
                            }
                        }
                    }

                }
                else {
                    const quantityWrapper = document.querySelector(`.quantity-wrapper[data-variant-id="${cartKey}"]`);
                    //console.log('Updating quantity from cart drawer',quantityWrapper);
                    if (quantityWrapper) {
                        const cartQuantityElement = quantityWrapper.querySelector(".cart-quantity");
                        if (cartQuantityElement) {
                            if (updatedQuantity === 0) {
                                quantityWrapper.classList.remove("active-qty");
                                quantityWrapper.parentElement.querySelector('.add-to-cart-btn')?.classList.remove('hide-atc_btn');
                                return;
                            }
                            cartQuantityElement.textContent = updatedQuantity;
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching cart:", error);
            }
        }
    });
}();